import attendo from '../img/logos/attendo.jpg';
import caruna from '../img/logos/Caruna.png';
import elenia from '../img/logos/Elenia.png';
import hehku from '../img/logos/hehku.png';
import kiertokapulaLogo from '../img/logos/kiertokapula-logo.png';
import lahtiAqua from '../img/logos/LahtiAqua.png';
import mehilainen from '../img/logos/Mehilainen.png';
import oomi from '../img/logos/Oomi.png';
import sanoma from '../img/logos/Sanoma.png';
import sato from '../img/logos/SATO.png';
import terveystalo from '../img/logos/Terveystalo.png';
import vare from '../img/logos/vare.png';

import bdx from '../img/logos/BDX.png';
import bredablickLogo from '../img/logos/Bredablick-logo.webp';
import carlsberg from '../img/logos/Carlsberg.jpg';
import ellevio from '../img/logos/Ellevio.png';
import feelgoodLogo from '../img/logos/feelgood-logo.png';
import greenCargo from '../img/logos/GreenCargo.png';
import hsb from '../img/logos/HSB.png';
import nge from '../img/logos/NGE.png';
import skoogs from '../img/logos/Skoogs.jpg';
import srv from '../img/logos/SRV.jpg';
import storumanEnergi from '../img/logos/StorumanEnergi.png';
import strawberryLogo from '../img/logos/strawberry-logo.png';

import aneoLogo from '../img/logos/Aneo_logo.svg.png';
import bodoEnergi from '../img/logos/BodoEnergi.png';
import cheapEnergy from '../img/logos/cheap_energy.webp';
import kildenKraft from '../img/logos/Kilden-kraft.webp';
import klarkraft from '../img/logos/klarkraft.png';
import meko from '../img/logos/Meko.png';
import motkraftAs from '../img/logos/motkraft_as.png';
import nordvestnettLogo from '../img/logos/nordvestnett-logo.png';
import norskGjenvinning from '../img/logos/norsk_gjenvinning.webp';
import sagaEnergi from '../img/logos/SagaEnergi.png';
import schenkerLogo from '../img/logos/Schenker_logo.png';
import veniMeteringGreen from '../img/logos/VENIMetering_Green.png';

import peliasLogo from '../img/logos/Pelias.jpg'
import anticimexLogo from '../img/logos/anticimexlogo.png'
import skandiaEnergiLogo from '../img/logos/Skandiaenergi_logo.webp'

import useI18n from "./useI18n";

const logosGlobal = [
    { src: aneoLogo, alt: "Aneo" },
    { src: anticimexLogo, alt: "Anticimex" },
    { src: caruna, alt: "Caruna" },
    { src: feelgoodLogo, alt: "Feelgood" },
    { src: klarkraft, alt: "Klarkraft" },
    { src: peliasLogo, alt: "Pelias" },
    { src: sanoma, alt: "Sanoma" },
    { src: sato, alt: "SATO" },
    { src: skandiaEnergiLogo, alt: "Skandia Energi"},
    { src: srv, alt: "SRV" },
    { src: storumanEnergi, alt: "Storuman Energi" },
    { src: terveystalo, alt: "Terveystalo" }
];

const logosFi = [
    { src: attendo, alt: "Attendo" },
    { src: caruna, alt: "Caruna" },
    { src: elenia, alt: "Elenia" },
    { src: hehku, alt: "Hehku" },
    { src: kiertokapulaLogo, alt: "Kiertokapula" },
    { src: lahtiAqua, alt: "Lahti Aqua" },
    { src: mehilainen, alt: "Mehiläinen" },
    { src: oomi, alt: "Oomi" },
    { src: sanoma, alt: "Sanoma" },
    { src: sato, alt: "SATO" },
    { src: terveystalo, alt: "Terveystalo" },
    { src: vare, alt: "Väre" }
];

const logosSe = [
    { src: bdx, alt: "BDX" },
    { src: bredablickLogo, alt: "Bredablick" },
    { src: carlsberg, alt: "Carlsberg" },
    { src: ellevio, alt: "Ellevio" },
    { src: feelgoodLogo, alt: "Feelgood" },
    { src: greenCargo, alt: "Green Cargo" },
    { src: hsb, alt: "HSB" },
    { src: nge, alt: "NGE" },
    { src: skoogs, alt: "Skoogs" },
    { src: srv, alt: "SRV" },
    { src: storumanEnergi, alt: "Storuman Energi" },
    { src: strawberryLogo, alt: "Strawberry" }
];

const logosNo = [
    { src: aneoLogo, alt: "Aneo" },
    { src: bodoEnergi, alt: "Bodø Energi" },
    { src: cheapEnergy, alt: "Cheap Energy" },
    { src: kildenKraft, alt: "Kilden Kraft" },
    { src: klarkraft, alt: "Klarkraft" },
    { src: meko, alt: "Meko" },
    { src: motkraftAs, alt: "Motkraft AS" },
    { src: nordvestnettLogo, alt: "Nordvestnett" },
    { src: norskGjenvinning, alt: "Norsk Gjenvinning" },
    { src: sagaEnergi, alt: "Saga Energi" },
    { src: schenkerLogo, alt: "Schenker" },
    { src: veniMeteringGreen, alt: "VENI Metering Green" }
];

const logos = {
    fi: logosFi,
    se: logosSe,
    no: logosNo,
    global: logosGlobal
};

const useReferenceLogos = () => {
    const { getCountry } = useI18n();
    const country = getCountry();

    const resolveLogos = () => {
        return logos[country] ?? logos.fi;
    }

    return {
        resolveLogos
    };
}

export default useReferenceLogos;
